import lionHeadLogo from "../../assets/lion-head-logo.png";

/**
 * Faint, decorative lion-head mark used as a background accent.
 * Purely decorative — hidden from assistive tech and not interactive.
 */
export const LionWatermark = ({ className = "" }) => (
  <img
    src={lionHeadLogo}
    alt=""
    aria-hidden="true"
    draggable={false}
    className={`pointer-events-none absolute select-none opacity-[0.05] grayscale brightness-[1.8] ${className}`}
  />
);
